<div class="wallet_single_wrapper">
  <!--begin::Loyalty Points (Balance)-->
  <!-- <div *ngIf="configAccess[1]"> -->
  <div *ngIf="balance" class="single row wallet-row" (click)="openBalance()">
    <div class="col-9 single-content">
      <span class="wallet-img">
        <img src="../../../assets/media/images/Synergy-Icon.png" alt="Synergy" />
      </span>
      <div>

        <div class="single-title">{{'Synergy Points' | content_translate: 'title'}}</div>

        <!-- <div class="single-title">{{balance.text | content_translate: 'title'}}</div> -->
        <div class="single-subtitle"><span class="mdi mdi-shopping"></span>{{'MEMBER.DASHBOARD.WALLET_SUBTITLE' |
          translate}}
        </div>
      </div>
    </div>
    <div class="col-3 single-amount">
      <div *ngIf="balance">
        <span class="points">{{balance.currentPoints}}</span>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>

<!--begin::Loyalty Balance Modal-->
<ng-template #balanceModal let-c=" close" let-d="dismiss">
  <div class="container wallet-popup">
    <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="single balance-title row-flex">
      <span class="wallet-img">
        <img src="../../../assets/media/images/Synergy-Icon.png" alt="Synergy" />
      </span>
      <span *ngIf="balance" class="points">{{balance.currentPoints}}</span>
      <h4 class="balance-title">{{'Synergy Points' | content_translate: 'title'}}</h4>
    </div>
    <div class="balance-text mt-3">
      <p [innerHTML]="'Synergy Points' | content_translate: 'content'"></p>
    </div>
  </div>
</ng-template>
<!--end::Loyalty Balance Modal-->
